import request from '@/utils/requestVr'
/**
 * 获取存储信息
 * 该函数用于向服务器请求获取存储相关的信息
 * @returns {Promise} 返回一个Promise对象，包含服务器响应的存储信息数据
 */
export function getStorageInfo(params) {
    return request({ // 发起HTTP请求
        url: '/vr/storage/tenant/standard', // 请求的API端点路径
        method: 'get', // 请求方法为GET
        params,
    })
}
export function getTenantList() {
    return request({
        url: '/vr/tenants',
        method: 'get',
    })
}

export function getStorageCurve(params) {
    return request({
        url: 'vr/storage/tenant/curve',
        method: 'get',
        params,
    })
}

// 分配存储空间给代理
export function allocateStorage(data) {
  return request({
    url: '/vr/storage/enterprise/temp/add',
    method: 'post',
    data: data,
  })
}

// 获取分配记录
export function getStorageRecords(params) {
  return request({
    url: '/vr/storage/enterprise/temp/page',
    method: 'get',
    params: params,
  })
}

export function getArchiveList(params) {
  return request({
    url: 'vr/storage/expire/stat/renew/page/tenant',
    method: 'get',
    params,
  })
}

export function delObj(data) {
    return request({
        url: '/vr/storage/expire/stat/renew/delete',
        method: 'post',
        data: data,
    })
}

export function getArchiveDetail(params) {
    return request({
        url: '/vr/storage/expire/stat/renew/detail',
        method: 'get',
        params,
    })
}

// 创建归档续费订单
export function createArchiveRenewOrder(data) {
  return request({
    url: '/vr/storage/renew/add',
    method: 'post',
    data: data,
  })
}

// 检查归档支付状态
export function checkArchivePayStatus(params) {
  return request({
    url: '/vr/storage/renew/pay/status',
    method: 'get',
    params,
  })
}
